import ProductPreviewSection from "@/components/home/products/ProductPreviewSection";
import VoucherSection from "@/components/home/VoucherSection";
import HeroSection from "@/components/home/HeroSection";
import StripFeature from "@/components/home/StripFeature";
import { useContext } from "react";
import { AppContext } from "@/contexts/app-context";

import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

export default function Home() {
    const { app } = useContext(AppContext);
    const { t } = useTranslation();
    return (
        <>
            <Helmet>
                <title>{t("seo.home.title")}</title>
                <meta
                    name="description"
                    content={t("seo.home.description")}
                />
            </Helmet>
            {app && (
                <div className="w-full pt-22 pb-10 md:pt-10 md:pb-10 sm:max-w-[90%] mx-auto px-4 lg:px-8 space-y-8">
                    <HeroSection slides={app.home.hero} />
                    <ProductPreviewSection product={app.home.product} />
                    <VoucherSection vouchers={app.home.voucher} />
                    <StripFeature />
                </div>
            )}
        </>
    );
}
